<li class="nav-item">
  <link-element [ngClass]="customCssClass + ' ' + setActiveRouteStyle()" [route]="route">
    <ng-content></ng-content>
  </link-element>
</li>
